import { type FC } from 'react'
import { Modal } from '../../../components/Modal/Modal'

interface ConfirmDialogProps {
  title: string
  body: string
  confirmLabel?: string
  isLoading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({ title, body, confirmLabel = 'Confirm', isLoading = false, onConfirm, onCancel }) => (
  <Modal
    show
    onHide={onCancel}
    header={<h5 className='mb-0'>{title}</h5>}
    headerBodySeparator
    body={<div className='paragraph-small'>{body}</div>}
    showFooterActions
    footerPrimaryActionTitle={confirmLabel}
    footerPrimaryActionButtonVariant='danger'
    footerPrimaryActionLoading={isLoading}
    footerSecondaryActionTitle='Cancel'
    onFooterPrimaryAction={onConfirm}
    onFooterSecondaryAction={onCancel}
  />
)
